import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { quyetDinhHocVuApi } from "../../../api/xet-hoc-vu/quyetDinhHocVuApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { eQuyetDinhHocVuActionIds, IQuyetDinhHocVuActionTypes } from "../../action-types/xet-hoc-vu/IQuyetDinhHocVuActions";
import { IQuyetDinhHocVu } from "../../../model/response/xet-hoc-vu/IQuyetDinhHocVu";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";

const mainAction = rootActions.xetHocVu.quyetDinhHocVu;

export function* quyetDinhHocVuSaga(): any {
    yield takeLatest(eQuyetDinhHocVuActionIds.LOAD_BY_DOT_START, loadWorker);
    yield takeEvery(eQuyetDinhHocVuActionIds.SAVE_START, saveWorker);
    yield takeEvery(eQuyetDinhHocVuActionIds.DELETE_START, deleteWorker);
    yield takeLatest(eQuyetDinhHocVuActionIds.LOAD_SINH_VIEN_START, loadSinhVienWorker);
    yield takeEvery(eQuyetDinhHocVuActionIds.DONG_BO_KET_QUA_START, dongBoWorker);
    yield takeEvery(eQuyetDinhHocVuActionIds.ADD_SINH_VIEN_START, addSinhVienWorker);
    yield takeEvery(eQuyetDinhHocVuActionIds.REMOVE_SINH_VIEN_START, removeSinhVienWorker);
}

function* loadWorker(action: IQuyetDinhHocVuActionTypes): any {
    const id_dot_xet = action.payload as number;
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.GetListByDotXet, id_dot_xet);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải danh sách quyết định"));
    }
}

function* saveWorker(action: IQuyetDinhHocVuActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as IQuyetDinhHocVu;
    if (payload.id_quyet_dinh > 0) {
        res = yield call(quyetDinhHocVuApi.Update, payload.id_quyet_dinh, payload);
    } else {
        res = yield call(quyetDinhHocVuApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu quyết định"));
    }
}

function* deleteWorker(action: IQuyetDinhHocVuActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa quyết định"));
    }
}

function* loadSinhVienWorker(action: IQuyetDinhHocVuActionTypes): any {
    const id_quyet_dinh = action.payload as number;
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.GetSinhVien, id_quyet_dinh);
    if (res.is_success) {
        yield put(mainAction.LOAD_SINH_VIEN_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_SINH_VIEN_ERROR(res.message ?? "Có lỗi khi tải sinh viên của quyết định"));
    }
}

function* dongBoWorker(action: IQuyetDinhHocVuActionTypes): any {
    const id_quyet_dinh = action.payload as number;
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.DongBoKetQua, id_quyet_dinh);
    if (res.is_success) {
        yield put(mainAction.DONG_BO_KET_QUA_SUCCESS(res.data));
        yield put(mainAction.LOAD_SINH_VIEN_START(id_quyet_dinh));
    } else {
        yield put(mainAction.DONG_BO_KET_QUA_ERROR(res.message ?? "Có lỗi khi đồng bộ sinh viên"));
    }
}

function* addSinhVienWorker(action: IQuyetDinhHocVuActionTypes): any {
    const payload = action.payload as { id_quyet_dinh: number, ids: string[] };
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.AddSinhVien, payload.id_quyet_dinh, payload.ids);
    if (res.is_success) {
        yield put(mainAction.ADD_SINH_VIEN_SUCCESS(res.data));
        yield put(mainAction.LOAD_SINH_VIEN_START(payload.id_quyet_dinh));
    } else {
        yield put(mainAction.ADD_SINH_VIEN_ERROR(res.message ?? "Có lỗi khi thêm sinh viên"));
    }
}

function* removeSinhVienWorker(action: IQuyetDinhHocVuActionTypes): any {
    const payload = action.payload as { id_quyet_dinh: number, ids: number[] };
    const res: IBaseResponse = yield call(quyetDinhHocVuApi.RemoveSinhVien, payload.ids);
    if (res.is_success) {
        yield put(mainAction.REMOVE_SINH_VIEN_SUCCESS(res.data));
        yield put(mainAction.LOAD_SINH_VIEN_START(payload.id_quyet_dinh));
    } else {
        yield put(mainAction.REMOVE_SINH_VIEN_ERROR(res.message ?? "Có lỗi khi gỡ sinh viên"));
    }
}
